import { render, staticRenderFns } from "./ButtonProvider.vue?vue&type=template&id=5df166ab&scoped=true&"
import script from "./ButtonProvider.vue?vue&type=script&lang=js&"
export * from "./ButtonProvider.vue?vue&type=script&lang=js&"
import style0 from "./ButtonProvider.vue?vue&type=style&index=0&id=5df166ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df166ab",
  null
  
)

export default component.exports